// Types
import { getObjectId } from './getObjectId';
/**
 * The given object has an object id
 *
 * @param {Identifiable<object>} value
 *
 * @return {boolean}
 */
export var hasObjectId = function (value) { return getObjectId(value) !== null; };
//# sourceMappingURL=hasObjectId.js.map